import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TopicsState } from '../../store';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-topic-action-bar',
  templateUrl: './topic-action-bar.component.html',
  styleUrls: ['./topic-action-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, TranslatePipe]
})
export class TopicActionBarComponent {
  private readonly topicsState = inject(TopicsState);

  topicsFilter = this.topicsState.topicsFilter;

  readonly calendarModification = input(false);

  public updateVisibleTopics(type: string): void {
    this.topicsState.updateCategories(type);

    const allOff = this.topicsState.topicsFilter().categories.every(category => !category.active);

    if (allOff) {
      this.topicsState.resetCategories();
    }
  }

  public resetCategoryFilter(): void {
    this.topicsState.resetCategories();
  }
}
